import { useTranslation } from 'next-i18next'
// Dependencies.
import styled, { css } from 'styled-components'
import { useContext, useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import { SectionField } from '../../Inputs/SectionField'
import { GroupSizeInput } from './GroupSizeInput'
import { PrivacyInput } from './PrivacyInput'
import { EventHookInterface } from '../../../types'
import { forScreensGreaterThanMobileWidth } from '../../../utils'
import { EventFareTypeInput } from './EventFareTypeInput'
import { EventFareInput } from './EventFareInput'
import { AttendanceInput } from '../AttendanceInput'
import { GroupContext, UserContext } from '../../../context'
// Div.
const Div = styled.div`
  display: flex;
  flex-wrap: wrap;

  .formField {
    flex-shrink: 0;
    margin-bottom: 20px;
    text-align: left;
    margin-right: 20px;
    width: 100%;
    ${forScreensGreaterThanMobileWidth(css`
      width: 325px;
    `)}
  }

  .formField:last-child {
    margin-bottom: 0;
  }

  .selectInput {
    width: 100%;
  }
`

const P = styled.div`
  text-align: left;
  max-width: 400px;
`

// Props.
interface Props {
  eventHook: EventHookInterface
  groupId?: number
}

// Event Ticket Field.
export const EventTicketField: React.FC<Props> = ({ eventHook, groupId }) => {
  const { t } = useTranslation('common')
  const router = useRouter()

  const { currentUser } = useContext(UserContext)
  const { fetchGroup } = useContext(GroupContext)

  const [fetchedGroup, setFetchedGroup] = useState(null)

  useEffect(() => {
    setFetchedGroup(null)

    if (groupId) {
      fetchGroup(groupId).then((group) => {
        setFetchedGroup(group)
      })
    } else {
      if (currentUser) {
        if (currentUser.managed_groups.length == 0) {
          router.push('/dashboard')
        } else {
          fetchGroup(currentUser.managed_groups[0].id).then((group) => {
            setFetchedGroup(group)
          })
        }
      }
    }
  }, [groupId, currentUser])

  return (
    <SectionField
      header={t(`Event admission`, `Event admission`)}
      subheader={t(
        `EventTicketField-1633236459`,
        `Select the number of spots available for this event. Learn more about charging a ticket price for your event here.`,
      )}>
      <Div>
        {/* Fare Type. */}
        <EventFareTypeInput eventHook={eventHook} fetchedGroup={fetchedGroup} />

        {/* Event Ticket */}
        <EventFareInput eventHook={eventHook} fetchedGroup={fetchedGroup} />
      </Div>

      <Div>
        {/* Group Size. */}
        <AttendanceInput eventHook={eventHook} />
      </Div>
    </SectionField>
  )
}
